import { get, writable } from 'svelte/store';
import './region';
import InputScale from '../../components/surveys/InputScale.svelte';
import InputSelect from '../../components/surveys/InputSelect.svelte';
import InputText from '../../components/surveys/InputText.svelte';
import InputNumber from '../../components/surveys/InputNumber.svelte';
import InputCheckbox from '../../components/surveys/InputCheckbox.svelte';
import { isInteger, range } from 'lodash';
const scale_label_effect = ["เชิงลบอย่างมาก", "ทั้งบวกทั้งลบ", "เชิงบวกอย่างมาก"];
const scale_label_trust = ["เชื่อมั่นน้อย", "เฉยๆ", "เชื่อมั่นมาก"];
const scale_label_hope = ["สิ้นหวังมาก", "เฉยๆ", "มีหวังมาก"];
export class ScaleInput {
    constructor(field, label, scale_label) {
        this.field = field;
        this.label = label;
        this.scale_label = scale_label;
        this.type = 'scale';
        this.value = writable(null);
        this.component = InputScale;
    }
    validator() {
        const v = get(this.value);
        return isInteger(v) && -2 <= v && v <= 2;
    }
}
export class TextInput {
    constructor(field, label) {
        this.field = field;
        this.label = label;
        this.type = 'text';
        this.value = writable('');
        this.component = InputText;
    }
    validator() {
        return !!get(this.value);
    }
}
export class NumberInput {
    constructor(field, label, datalist = []) {
        this.field = field;
        this.label = label;
        this.datalist = datalist;
        this.type = 'number';
        this.value = writable('');
        this.component = InputNumber;
    }
    validator() {
        return !!get(this.value);
    }
}
export class SelectInput {
    constructor(field, label, choice) {
        this.field = field;
        this.label = label;
        this.choice = choice;
        this.type = 'select';
        this.value = writable(null);
        this.component = InputSelect;
    }
    validator() {
        const keys = this.choice.map(c => c.key);
        return keys.includes(get(this.value));
    }
}
export class CheckboxInput {
    constructor(field, label) {
        this.field = field;
        this.label = label;
        this.type = 'checkbox';
        this.value = writable(true);
        this.checked = writable(false);
        this.component = InputCheckbox;
    }
    validator() {
        return !!get(this.checked);
    }
}
export class Html {
    constructor(value) {
        this.value = value;
    }
}
export const questions = [
    {
        id: 'question-page-1-personal-information',
        progress: 4,
        form: [
            new Html(`<h1 class='font-bold text-2xl mt-8'>ร่วมลงรายชื่อ</h1>`),
            new TextInput("name", "ชื่อจริง"),
            new TextInput("surname", "นามสกุล"),
            new NumberInput("generation", "ต.อ. รุ่น", range(95, 0, -1)),
            new CheckboxInput("is_triamudom", "ฉันยืนยันว่าฉันเป็นศิษย์เก่า-ศิษย์ปัจจุบันของโรงเรียนเตรียมอุดมศึกษา"),
        ]
    },
];
